import slotShouldForwardProp from "./slotShouldForwardProp.js";
var rootShouldForwardProp = function rootShouldForwardProp(prop) {
  return slotShouldForwardProp(prop) && prop !== 'classes';
};
export default rootShouldForwardProp;